import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import ChangePlan from "./ChangePlan";

function epochToHuman(epochTime) {
    const date = new Date(epochTime * 1000);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Intl.DateTimeFormat(undefined, options).format(date);
  }
  
export default function SubscriptionInfo(){
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    const [subscriptionDetails, setSubscriptionDetails] = useState(null);
    const [fetching, setFetching] = useState(false);
    
    const handleGetStatus = (status) => {
        switch (status) {
            case 'trialing':
                return <span className="badge badge-primary">On-Trial</span>;
            case 'cancelled':
                return <span className="badge badge-danger">Cancelled</span>;
            case 'active':
                return <span className="badge badge-success">Active</span>;
            default:
                break;
        }
    };
    
    const handleRetrieveSubscriptionInfo = async () => {
        setFetching(true);
        await Axios.get(`api/v2/subscriptions/${subscription_details?.subscription_id}`)
        .then(res => {
            setSubscriptionDetails(res.data.subscription_details);
        })
        .finally(() => {
            setFetching(false);
        });
    };
    
    useEffect(() => {
        handleRetrieveSubscriptionInfo();
    }, []);

    return(
        <div className="d-flex flex-column">
            <div className="d-flex flex-row">
                <div className="d-flex flex-column w-100">
                    {fetching && (
                        <div className="w-50">
                            <Skeleton variant="text" width={'100%'} height={30} />
                            <Skeleton variant="text" width={'100%'} height={30} />
                            <Skeleton variant="text" width={'100%'} height={30} />
                        </div>
                        
                    )}
                    {!fetching && (
                        <>
                        <h2 className="m-0 font-weight-bold">{subscriptionDetails?.subscription_plan}</h2>
                        <p className="form-text text-muted pt-2">
                            {`$${String(subscriptionDetails?.subscription_price).slice(0, -2)}/month, you are currently on the ${subscriptionDetails?.subscription_plan} that renews monthly.`}
                        </p>
                        <h3 className="m-0 mt-2 font-weight-bold">Current Plan Includes:</h3>
                        <ul>
                            <li style={{fontSize: "16px"}}>Timeline</li>
                            <li style={{fontSize: "16px"}}>Basics</li>
                            <li style={{fontSize: "16px"}}>Estate</li>
                            <li style={{fontSize: "16px"}}>Budget</li>
                            <li style={{fontSize: "16px"}}>Children</li>
                        </ul>
                        </>
                    )}
                </div>
                <div className="ml-auto">
                    {!fetching && handleGetStatus(subscriptionDetails?.status)}
                </div>
            </div>
            {!fetching && subscriptionDetails?.status !== 'trialing' && (
                <h5 className="m-0 mt-4 font-weight-light">Next Billing Date: <strong className="font-weight-bold">April 15, 2025</strong></h5>
            )}
            {subscriptionDetails?.status === 'trialing' && (
                <h5 className="m-0 mt-4 font-weight-light">Trial Ends At: <strong className="font-weight-bold">{epochToHuman(subscriptionDetails?.trial_end)}</strong></h5>
            )}
            <div className="mt-3 d-flex flex-row">
                    <ChangePlan subscription={subscriptionDetails}/>
                    <button
                        type="button"
                        className="ml-auto btn btn-light-danger font-weight-bold btn-sm"
                    >
                        Cancel Subscription
                    </button>
            </div>
        </div>
    );
};